// Inserts text at the caret of the designMode iframe editor, or at the end of the body when there is no caret inside it.
export const insertTextAtCursor = (iframe, text) => {
    const win = iframe?.contentWindow;
    const doc = iframe?.contentDocument || win?.document;
    if (!doc?.body || !text) return false;
    win?.focus();
    const selection = doc.getSelection();
    let range = selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : null;
    if (!range || !doc.body.contains(range.commonAncestorContainer)) {
        range = doc.createRange();
        range.selectNodeContents(doc.body);
        range.collapse(false);
    }
    range.deleteContents();
    const node = doc.createTextNode(text);
    range.insertNode(node);
    range.setStartAfter(node);
    range.collapse(true);
    if (selection) {
        selection.removeAllRanges();
        selection.addRange(range);
    }
    return true;
};
